import { useState, useEffect } from "react";

const DEFAULT_DELAY_MS = 300;

const useDebouncedValue = (value, delayMs = DEFAULT_DELAY_MS) => {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
};

export default useDebouncedValue;
